import { render, staticRenderFns } from "./DataOptimization.vue?vue&type=template&id=7abd5cc4&"
import script from "./DataOptimization.vue?vue&type=script&lang=js&"
export * from "./DataOptimization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports